module.exports = __webpack_public_path__ + "public/Icons/manage_payout.svg?d750a742";